import { doc, getDoc, collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from './config';
import { QuestionEntity, TestQuizEntity } from '../types';

export async function fetchIntroduction(keyword: string): Promise<QuestionEntity | null> {
  try {
    const snap = await getDoc(doc(db, 'introduction', keyword));
    if (!snap.exists()) return null;
    return snap.data() as QuestionEntity;
  } catch (e: any) {
    console.error('fetchIntroduction error:', e?.code, e?.message);
    throw e;
  }
}

export async function fetchPractice(testIdentifier: string): Promise<TestQuizEntity[]> {
  const q = query(
    collection(db, 'practice'),
    where('testIdentifier', '==', testIdentifier),
    orderBy('problemNo', 'asc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data() as TestQuizEntity);
}

export async function fetchRehearsal(testIdentifier: string): Promise<TestQuizEntity[]> {
  const q = query(
    collection(db, 'rehearsal'),
    where('testIdentifier', '==', testIdentifier),
    orderBy('problemNo', 'asc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data() as TestQuizEntity);
}
